import { type MouseEvent, useCallback } from 'react'

import { CardModalFallback } from '@/components/common/Card/CardModal/CardModalFallback/CardModalFallback'
import { CardModalLoading } from '@/components/common/Card/CardModal/CardModalLoading/CardModalLoading'
import { type RecType } from '@/defs/rec'
import { useCardLink } from '@/hooks/useCardLink'
import { useModal } from '@/hooks/useModal'
import { isModifiedClick } from '@/utils/commonUtil'
import { createDynamicComponent } from '@/utils/factoryUtil'

type Props = {
  rec: RecType
}

const CardModal = createDynamicComponent({
  fallback: <CardModalFallback />,
  loader: async () => import('@/components/common/Card/CardModal/CardModal'),
  loading: ({ pastDelay }) => (pastDelay ? <CardModalLoading /> : null),
  name: 'CardModal',
})

export const useCardModalButton = ({ rec }: Props) => {
  const cardLink = useCardLink({ rec })
  const { open } = useModal(`rec-${rec.cardId}-${rec.partnerRef?.cardId || 'none'}`)

  const onClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      if (isModifiedClick(e)) return
      e.preventDefault()
      open({
        content: <CardModal rec={rec} />,
        disablePointerEvents: true,
        variant: 'nobox',
        width: 'full',
      })
    },
    [open, rec],
  )

  return { cardLink, onClick }
}
